module.exports = __webpack_public_path__ + "img/enmologo.4240221c.svg";